import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import { NIP19Page } from "./pages/NIP19Page";
import { CreateListPage } from "./pages/CreateListPage";
import { EditListPage } from "./pages/EditListPage";
import RemoteLoginSuccessPage from "./pages/RemoteLoginSuccessPage";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/create" element={<CreateListPage />} />
        <Route path="/edit/:dTag" element={<EditListPage />} />
        {/* Callback target for NIP-46 signer apps (e.g. Amber) after approval */}
        <Route path="/remoteloginsuccess" element={<RemoteLoginSuccessPage />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;
